import { render, staticRenderFns } from "./TransportOrderUpload.vue?vue&type=template&id=5ad4635c&scoped=true"
import script from "./TransportOrderUpload.vue?vue&type=script&lang=js"
export * from "./TransportOrderUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad4635c",
  null
  
)

export default component.exports